"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var MemoryStorage = (function () {
    function MemoryStorage() {
        this.data = {};
    }
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () { return Object.keys(this.data).length; },
        enumerable: true,
        configurable: true
    });
    MemoryStorage.prototype.getItem = function (key) { return this.data[key]; };
    MemoryStorage.prototype.setItem = function (key, value) { this.data[key] = value; };
    MemoryStorage.prototype.removeItem = function (key) { delete this.data[key]; };
    MemoryStorage.prototype.clear = function () { this.data = {}; };
    MemoryStorage.prototype.key = function (num) { return Object.keys(this.data)[num]; };
    return MemoryStorage;
}());
MemoryStorage = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], MemoryStorage);
exports.MemoryStorage = MemoryStorage;
//# sourceMappingURL=memory-storage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/utils/dist/services/memory-storage.js
// module id = 157
// module chunks = 4